import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Avatar,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../Common/Pagination/Pagination";
import { ToastContainer } from "react-toastify";
import { ArchivedMembersAction } from "../../../Redux/action/ArchivedMembersAction";
import { Link, useLocation } from "react-router-dom";
import { TbExternalLink } from "react-icons/tb";

const ArchivedMembers = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [search, setSearch] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const vId = queryParams.get("vendorId");

  const dispatch = useDispatch();
  const { userResult } = useSelector((state) => state.Auth);
  const vendorId = vId || userResult?.vendorid;

  const userInfo = useSelector((state) => state.ArchivedMembers?.result?.content);
  const totalPages = useSelector((state) => state.ArchivedMembers?.result?.totalPages);

  useEffect(() => {
    dispatch(
      ArchivedMembersAction({
        vendorId,
        search,
        pageNumber,
      })
    );
  }, [pageNumber, search]);

  const handlePageChange = (page) => setPageNumber(page);

  return (
    <Box sx={{ mt: 3 }} className="common_wrapper">
      <ToastContainer />

      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 2,
          borderRadius: 3,
          border: "1px solid #E5E8EB",
          background: "#ffffff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#0E3F6F" }}>
          Deactivated Team Members
        </Typography>
      </Paper>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          border: "1px solid #E5E7EB",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ background: "#F9FAFB", textTransform: "uppercase" }}>
              <TableCell sx={{ fontWeight: 600 }}>Candidate</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Designation</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Location</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Mobile</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Reason</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {userInfo?.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  transition: "0.2s",
                  "&:hover": { background: "#F5FAFF" },
                }}
              >
                {/* Candidate Cell with Avatar */}
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.8 }}>
                    <Avatar
                      sx={{
                        width: 45,
                        height: 45,
                        bgcolor: "#0E3F6F",
                        fontSize: "15px",
                        fontWeight: 600,
                      }}
                    >
                      {item?.candidateName
                        ?.split(" ")
                        ?.map((n) => n[0])
                        .join("")
                        .toUpperCase() || "NA"}
                    </Avatar>

                    <Box>
                      <Typography sx={{ fontWeight: 600 }}>
                        {item?.candidateName || "N/A"}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", color: "#6b7280", fontWeight: 600 }}>
                        ID: {item?.candidateEmpId}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>

                <TableCell>{item?.candidateDesignation || "N/A"}</TableCell>
                <TableCell>{item?.candidateEmail || "N/A"}</TableCell>
                <TableCell>{item?.candidateAddress || "N/A"}</TableCell>
                <TableCell>{item?.candidateMobile || "N/A"}</TableCell>

                {/* Reason Tooltip */}
                <TableCell>
                  <Tooltip title={item?.reason || "No reason provided"}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#475569",
                        maxWidth: 140,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item?.reason || "N/A"}
                    </Typography>
                  </Tooltip>
                </TableCell>

                {/* Actions */}
                <TableCell>
                  <Tooltip title="View Profile">
                    <IconButton
                      component={Link}
                      to={`/candidate-profile-view/${item?.candidateId}`}
                    >
                      <TbExternalLink size={20} color="#0E3F6F" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Empty State */}
      {!userInfo?.length && (
        <Typography sx={{ textAlign: "center", py: 3, color: "#6b7280" }}>
          No archived records found
        </Typography>
      )}

      {/* Pagination */}
      {userInfo?.length > 0 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Pagination
            totalPages={totalPages}
            currentPage={pageNumber}
            onPageChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default ArchivedMembers;
